module.exports = __webpack_public_path__ + "img/recycle.81eff9b9.svg";